import { TGetTierResponse } from "services/types";

export const mockGetTier: TGetTierResponse = {
  tierList: [
    {
      name: "Essencial",
      active: "Y",
      startDate: "01/26/2024 11:58:35",
      endDate: "01/27/2024 00:00:00",
      memberName: "O VALE DO SILÊNCIO SA",
      miles: "0",
    },
    {
      name: "Essencial",
      active: "N",
      startDate: "01/26/2024 00:00:00",
      endDate: "",
      memberName: "O VALE DO SILÊNCIO SA",
      miles: "0",
    },
    {
      name: "VoeBiz",
      active: "N",
      startDate: "01/18/2024 00:00:00",
      endDate: "01/25/2024 23:59:59",
      memberName: "O VALE DO SILÊNCIO SA",
      miles: "0",
    },
  ],
  userInfo: {
    memberNumber: "183579723",
    memberSince: "01/18/2024 12:03:12",
    miles: "0",
    dateUpgradeLimit: "01/28/2024",
    tierDateInfo: "Acumule milhas qualificáveis e conquiste a categoria Essencial",
    showUpgrade: true,
    upgradeInfo: {
      nextTier: "Prime",
      milesUpgrade: "70000",
      milesMaintenance: "1",
      totalMilesClub: "",
    },
  },
  tips: {
    cardList: [
      {
        title: "Voe GOL",
        description:
          "Trechos comprados ou resgatados com milhas na Smiles para voar GOL acumulam trechos qualificáveis que te ajudam a subir de categoria.",
        actionTarget: "buscar-voos",
      },
    ],
  },
};
